import type { FC, ReactElement } from "react";

import useContactFilterResetting from "app/pages/sales-intelligence/modules/leads-search-filters/hooks/useContactFilterResetting";

import ContactsSearchTextBoxContainer from "../../components/ContactsSearchTextBox/ContactsSearchTextBoxContainer";

import type { IContactSearchResultTableContainerProps } from "./ContactSearchResultTableContainer";
import ContactSearchResultTableContainer from "./ContactSearchResultTableContainer";
import { StyledSectionContainer } from "./styles";

interface IContactsSearchResultsSectionProps extends IContactSearchResultTableContainerProps {
    actionsPanel?: ReactElement;
}

const ContactsSearchResultsContainer: FC<IContactsSearchResultsSectionProps> = ({
    actionsPanel,
    isError,
    isLoading,
    createColumnsConfigFactory,
    ...contactsResultsTableProps
}) => {
    useContactFilterResetting();

    return (
        <StyledSectionContainer>
            {actionsPanel}
            <ContactsSearchTextBoxContainer isDisabled={isLoading || isError} />
            <ContactSearchResultTableContainer
                {...contactsResultsTableProps}
                isLoading={isLoading}
                isError={isError}
                createColumnsConfigFactory={createColumnsConfigFactory}
            />
        </StyledSectionContainer>
    );
};

export default ContactsSearchResultsContainer;
